<template>
  <div class="note-entry">
    <div class="note" v-if="fieldNotes.larval">
      <span class="title">Larval Site Master: </span>
      {{ fieldNotes.larval }}
    </div>
    <div class="note" v-if="fieldNotes.trap">
      <span class="title">Trap Site Master: </span>
      {{ fieldNotes.trap }}
    </div>
    <div class="note" v-if="!fieldNotes.larval && !fieldNotes.trap">
      None
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    fieldNotes: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.note-entry {
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;

  & .title {
    color: #757575;
  }

  & .note {
    color: rgba(0, 0, 0, 0.87);

    &:not(:first-child) {
      margin-top: 1rem;
    }
  }
}
</style>
